import { StyleToggle } from "./_static/_styleToggle";
import { HelperGHeader } from "./_helper/_helperGHeader";

export class GHeader extends HelperGHeader {
  constructor() {
    super();
    this.startPos = 0;
    this.scrollPos = 0;
  }

  scrollX() {
    this.gHeader.style.left = `-${window.pageXOffset}px`;
  }

  scrollY() {
    this.scrollPos = window.pageYOffset;
    if (
      this.startPos < this.scrollPos &&
      this.scrollPos > this.gHeader.clientHeight
    ) {
      // StyleToggle.active([this.gHeader]);
      this.gHeader.classList.add("gHeader-scrolled");
    } else {
      // StyleToggle.inactive([this.gHeader]);
      if (this.scrollPos < this.gHeader.clientHeight) {
        this.gHeader.classList.remove("gHeader-scrolled");
      }
    }
    this.startPos = this.scrollPos;
  }
}
